import { MaskOptions, useMask } from '@react-input/mask';
import { FC, HTMLProps } from 'react';
import { SizeType } from '../../types/props';
import { Input } from './input';

export interface MaskedInputProps
  extends MaskOptions,
    Omit<HTMLProps<HTMLInputElement>, 'size' | 'onChange' | 'label' | 'required'> {
  size?: SizeType;
  onChange?: (value: string) => void;
}

export const MaskedInput: FC<MaskedInputProps> = (props) => {
  const { mask, replacement = { _: /\d/ }, showMask = true, onChange, ...other } = props;

  const ref = useMask({
    mask,
    replacement,
    showMask,
  });

  return <Input {...other} ref={ref} onChange={(e) => onChange?.(e.currentTarget.value)} />;
};
